// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
    production: false,
    // TODO: Update url once everything is ready
    consoleUrl: 'https://app509.sjc2.turn.com:8443',
    dspApiUrl: 'https://amobee-cloud-gateway-staging.us-east-1.prod.k8s.amobee.com',
    ccpApiUrl: 'https://amobee-cloud-gateway-staging.us-east-1.prod.k8s.amobee.com'
};